import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';

const $= window.$;

class Evaluator extends Component {
	constructor(props) {
		super(props);

        this.state={
            asse_id : this.props.params.asse_id,
            learner : this.props.params.lear_id,
            dated : '',
            ass_details:[],
            lr_details:[],
            check_done:0,
            corp : '',
            prod : '',
            experience : '',
            country : ''
        };
        this.getEvaluator = this.getEvaluator.bind(this);
        this.changeState = this.changeState.bind(this);
        this.AcceptReject = this.AcceptReject.bind(this);
	}

    componentDidMount() {
    	this.getEvaluator();
    	let div = document.querySelector('body');
		div.id = 'bodyid';
		div.setAttribute('class','inner');

    }

    AcceptReject(type){
    	fetch(Config.domainUrl+'evaluators/update-status', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    assessor_id : this.state.asse_id,learner_id:this.state.learner,type:type,ass_details:this.state.ass_details,lr_details:this.state.lr_details
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               //	alert(JSON.stringify(responseJson));
               	if(responseJson.status == 0 ){
               		Common.message(responseJson.message, responseJson.errors, "error");
               	}
               	else{
               		Common.message("", responseJson.message, "success");
               		this.getEvaluator();
               		$("#Show").css('display','none');
               	}

   		 });
    }

    changeState(){
    	
    	$('#Show').css('display','');
    }

    getEvaluator(){

    	fetch(Config.domainUrl+'evaluators/getdetails', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    assessor_id : this.state.asse_id,learner_id:this.state.learner,
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               //	alert(JSON.stringify(responseJson));
               	if(responseJson.status != 0 ){

	               	this.setState({
	               		ass_details : responseJson.extra.asse_details,
	               		lr_details : responseJson.extra.learner_details,
	               		check_done : responseJson.extra.check,
	               		dated : responseJson.extra.date,
	               		corp : responseJson.extra.corporate,
	               		prod : responseJson.extra.product,
	               		experience : responseJson.extra.experience,
	               		country : responseJson.extra.country,
	               	});
               	}

   		 });
    }


		render() {
			
			let monthNames = Common.monthNames;
			let d=new Date(), jDate=d.getDate(), jMonth=monthNames[d.getMonth()], jYear=d.getFullYear();

			return (
				<div className="row">
					<header>
						<div className="logo"><img src={process.env.PUBLIC_URL+'/images/logo.png'} alt="361°minds&trade;" title="361°minds&trade;" border="0"/></div>
						<div className="top-links reg-page"><img src={process.env.PUBLIC_URL+'/images/calendar_icon.png'} alt="" title="" border="0"/>{this.state.dated}</div>
					</header>
					<section className="maincontent">
						<section className="content paymentthanks">
							<div id="inner">
								<h1>{(this.state.check_done==0)?'Accept / Decline my request':(this.state.ass_details!=undefined)?(this.state.ass_details.approved==1)?'Accepted my request':'Declined my request':''}</h1>
							    <div className="margtop">
						            <table cellPadding="0" cellSpacing="0" border="0">
							          	<tbody>
								            <tr>
								              <td colSpan="2" valign="top"> Dear <strong>{(this.state.ass_details!=undefined)?(this.state.ass_details.gender==1)?'Mr.'+this.state.ass_details.name:'Ms.'+this.state.ass_details.name:''},</strong><br/><br/> Thanks for considering my request.{(this.state.check_done==0)?'I would appreciate if you accept to be my Evaluator for this program.':''}Please <a href="javascript:void(0)" className="orange1" onClick={(e)=>this.changeState(e)}>Click Here</a> to  view my complete profile. <br /><br /><b>Best regards,</b><br/> <strong>{(this.state.lr_details!=undefined)?this.state.lr_details.firstname+' '+this.state.lr_details.lastname:''}</strong><br /><br/></td>
								            </tr>
								            <tr id="Show" style={{display:'none'}}>
              									<td>
              										<div style={{paddingTop:'8px', borderTop:'dashed 1px #dddddd', margin:'0px'}}>
              											<table cellpadding="0" cellspacing="0" border="0">
                    										<tbody>	
                    											<tr>
										                      		<td width="300"><strong>Customer Name</strong></td>
										                      		<td width="50">:</td>
										                      		<td width="60%">{this.state.corp}</td>
										                      	</tr>
										                      	<tr className="trcolor">
											                      <td><strong>Program Name</strong></td>
											                      <td>:</td>
											                      <td>{this.state.prod}</td>
											                    </tr>
											                    <tr>
											                      <td><strong>Email</strong></td>
											                      <td>:</td>
											                      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.email:'-'}</td>
											                    </tr>
											                     <tr className="trcolor">
											                      <td><strong>Mobile</strong></td>
											                      <td>:</td>
											                      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.country_code+'-'+this.state.lr_details.mobile:'-'}</td>
											                    </tr>
											                    <tr>
											                      <td><strong>Gender</strong></td>
											                      <td>:</td>
											                      <td>{(this.state.lr_details!=undefined)?(this.state.lr_details.gender==1)?'Male':'Female':'-'}</td>
											                    </tr>
											                    <tr className="trcolor">
											                      <td><strong>Date of Birth</strong></td>
											                      <td>:</td>
											                      <td>{(this.state.lr_details!=undefined)?(this.state.lr_details.dob!='0000-00-00' || this.state.lr_details.dob!= '' )?this.state.lr_details.dob:'-':''}</td>
											                    </tr>
											                    {(this.state.lr_details!=undefined)?(this.state.lr_details.occupation==1)?
											                    	[<tr>
												                      <td><strong>Course</strong></td>
												                      <td>:</td>
												                      <td>{this.state.lr_details.studying}</td>
												                    </tr>,
												                    <tr className="trcolor">
												                      <td><strong>Year of study</strong></td>
												                      <td>:</td>
												                      <td>{this.state.lr_details.yearofstudy}</td>
												                    </tr>,
												                    <tr>
														              <td><strong>College</strong></td>
														              <td>:</td>
														              <td>{this.state.lr_details.college}</td>
														            </tr>]
												                    :(this.state.lr_details.occupation==2)?
												                    [<tr>
												                      <td><strong>Education</strong></td>
												                      <td>:</td>
												                      <td>{this.state.lr_details.education}</td>
												                    </tr>,
												                    <tr className="trcolor">
												                      <td><strong>Designation</strong></td>
												                      <td>:</td>
												                      <td>{this.state.lr_details.designation}</td>
												                    </tr>,
												                    <tr>
												                      <td><strong>Experience</strong></td>
												                      <td>:</td>
												                      <td>{this.state.experience}</td>
												                    </tr>]
												                    :(this.state.lr_details.occupation==3)?
												                     <tr>
												                      <td><strong>Occupation</strong></td>
												                      <td>:</td>
												                      <td>{this.state.lr_details.others}</td>
												                    </tr>
												                    :''
												                    :''
											                    }
											                    <tr className="trcolor">
															      <td><strong>Location</strong></td>
															      <td>:</td>
															      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.location:'-'}</td>
															    </tr>
															    <tr>
															      <td><strong>City / Town</strong></td>
															      <td>:</td>
															      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.citytown:'-'}</td>
															    </tr>
															    <tr className="trcolor">
															      <td><strong>Region / state</strong></td>
															      <td>:</td>
															      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.regionstate:'-'}</td>
															    </tr>
															    <tr>
															      <td><strong>Country</strong></td>
															      <td>:</td>
															      <td>{this.state.country}</td>
															    </tr>
															    <tr className="trcolor">
															      <td><strong>About Learner</strong></td>
															      <td>:</td>
															      <td>{(this.state.lr_details!=undefined)?this.state.lr_details.aboutyourself:'-'}</td>
															    </tr>
									                      	</tbody>
									                    </table>
              										</div>
              									</td>
              								</tr>
								        </tbody>
							        </table>
						        </div>
						        {(this.state.check_done==0)?
							        <div className="button">
							            <input type="button"  value="I am happy to Accept" onClick={()=>this.AcceptReject('accept')} style={{marginLeft:'10px'}}/>
							            <input type="button"  value="Sorry. I Decline" onClick={()=>this.AcceptReject('reject')}/>
						            </div>:
						            ""
						        }
							</div>
						</section>
					</section>
					<footer>
						<span>Copyright &copy; 2006-{jYear},</span>
						<span>Threesixtyone Degree Minds Consulting Pvt Ltd.</span>
						<span className="f-lnk"><a href="javascript:void(0);">Privacy</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0);">Legal</a></span>
					</footer>
				</div>
			);
		}
}

export default Evaluator;



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Evaluator.js